import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from './ErrorBoundary';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
